import { Pipe, PipeTransform } from '@angular/core';

import { SchoolGroupInfo, SchoolInfo } from 'services/application/application.service';

@Pipe({
    name: 'schoolName'
})
export class SchoolNamePipe implements PipeTransform {
    transform(schoolNum: string, includeNumber: boolean, schools: SchoolInfo[], schoolgroups: SchoolGroupInfo[]) {
        if (!schoolNum) { return ''; }
        if ((!schools || !schools.length) && (!schoolgroups || !schoolgroups.length)) { return schoolNum; }

        // First try: is the provided school number a match to a known school group?
        const grp = (schoolgroups || []).filter(item => {
            if (item.LeadLocationNumber === schoolNum) { return true; }
            if (item.Schools && !!item.Schools.filter(sitem => sitem.LocationNumber === schoolNum).length) {
                return true;
            }
            return false;
        });

        if (grp && !!grp.length) {
            return grp[0].Name +
                (includeNumber === true ? ' (' + ('0000' + grp[0].LeadLocationNumber).slice(-4) + ')' : '');
        }

        // Second try. Either not in a group, or no groups found. Try all schools.
        const sch = (schools || []).filter(item => item.SchoolNumber === schoolNum);

        if (sch && !!sch.length) {
            return sch[0].SchoolName +
                (includeNumber === true ? ' (' + ('0000' + sch[0].SchoolNumber).slice(-4) + ')' : '');
        }

        return schoolNum;
    }
}
